import { Box, BoxProps, Typography, TypographyProps } from '@mui/material';
import { theme } from '../../../theme';

export interface TitleBarProps {
	BoxProps?: BoxProps;
	title: TypographyProps;
}

export const TitleBar = ({ BoxProps, title }: TitleBarProps) => {
	// vars
	const { sx = {}, ...boxProps } = BoxProps || {};

	return (
		<Box
			sx={{ backgroundColor: theme.palette.brand.grey[100], padding: theme.spacing(2), ...sx }}
			{...boxProps}>
			<Typography variant="h3" {...title} />
		</Box>
	);
};
